import { DateService } from '@core/services/date.service';
import { select, Store } from '@ngrx/store';
import { selectResults } from './../../../modules/results/store/results.selector';
import { filter, map, take } from 'rxjs/operators';
import { IHotelsAppState } from '../../../store/index';
import { selectSearchBoxParams } from '../../../store/router/router.selector';
import { SearchService } from './../../services/search.service';
import { DisneyUniversalParams } from './interfaces/disney_universa.interface';
import { Item } from './interfaces/item.interface';
import { EventItemParams } from './interfaces/item_params.interfeace';
import { ItemParams } from './item.class';
import { Meal_plan } from './meal_plan.enum';

export class EventItemParamsClass implements EventItemParams {
  public section = '-';
  public producto = '-';
  public dias = '-';
  public fechas = '-';
  public horas = '-';
  public anticipacion_de_compra = '-';
  public dias_de_producto = '-';
  public region_1 = '-';
  public plan_de_comida: null | Meal_plan = null;
  public cantidad_de_personas = '-';
  public servicios = '-';
  public recomendado: 'si' | 'no' = 'no';
  public cantidad_de_huespedes = '-';
  public cantidad_de_habitaciones = '-';
  public precio_por_edad = '-';
  public impuestos_tasas = '-';
  public logueo: 'si' | 'no' = 'no';
  public items: Item[] = [];
  private disney_city = '2359298';
  private universal_city = 'new6280590';
  constructor(
    private store$: Store<IHotelsAppState>,
    private searchService: SearchService,
    private dateService: DateService,
  ) {
    this.store$
      .pipe(
        select(selectSearchBoxParams),
        filter((data: any) => data !== undefined),
        map((data) => this.searchService.prepareSearchInfo(data)),
        take(1),
      )
      .subscribe((response) => {
        this.dias = ` ${this.dateService.getDay(response.checkin)} // ${this.dateService.getDay(
          response.checkout,
        )}`;
        this.fechas = this.searchService
          .getNormalizedDates(response.checkin, response.checkout)
          .replace(',', ' // ');
        this.anticipacion_de_compra = `${Math.round(
          this.dateService.differenceDays(response.checkin),
        )}`;
        this.dias_de_producto = `${Math.round(
          this.dateService.differenceDays(response.checkout, response.checkin),
        )}`;
        if (response.guests) {
          this.cantidad_de_personas = this.getCountGuest(response.guests.rooms);
          this.cantidad_de_huespedes = `${response.guests.total}`;
          this.cantidad_de_habitaciones = `${response.guests.selectedRooms}`;
        }
        this.producto =
          response.origin.id === this.disney_city
            ? 'disney'
            : response.origin.id === this.universal_city
            ? 'universa'
            : 'alojamiento';
      });

    this.section = 'plp';
  }

  private getCountGuest(rooms: any[]) {
    let adults = 0;
    let children = 0;
    let babys = 0;
    rooms.forEach((room) => {
      adults += room.adults;
      children += (room.childrenAges as any[]).filter((age) => age.value > 1).length;
      babys += room.childrenAges.filter((age) => age.value <= 1).length;
    });
    return `${adults} // ${children} // ${babys}`;
  }

  public getData() {
    const data = this.comunData();

    const dataByProvider = () => {
      if (data.producto === 'alojamiento') {
        return this.dataAlojamiento();
      } else {
        return this.dataDisneyUniversal();
      }
    };

    return {
      ...data,
      ...dataByProvider(),
    };
  }

  public getDataResume() {
    return {
      section: 'mapa',
      plan_de_comida: this.plan_de_comida,
      servicios: this.servicios,
      logueo: this.logueo,
      producto: this.producto,
    };
  }

  private comunData() {
    return {
      section: this.section.toLocaleLowerCase(),
      días: this.dias,
      fechas: this.fechas,
      horas: this.horas,
      anticipacion_de_compra: this.anticipacion_de_compra,
      dias_de_producto: this.dias_de_producto,
      plan_de_comida: this.plan_de_comida,
      cantidad_de_personas: this.cantidad_de_personas,
      servicios: this.servicios,
      cantidad_de_huespedes: this.cantidad_de_huespedes,
      cantidad_de_habitaciones: this.cantidad_de_habitaciones,
      precio_por_edad: this.precio_por_edad,
      impuestos_tasas: this.impuestos_tasas,
      logueo: this.logueo,
      items: this.items,
      producto: this.producto,
    };
  }

  public dataAlojamiento() {
    this.store$.pipe(select(selectResults), take(1)).subscribe((response) => {
      if (response.destination !== null) {
        this.region_1 = response.destination.country.name;
      }
    });

    return {
      region: (this.region_1 as string).toLowerCase(),
      recomendado: this.recomendado,
    };
  }

  public dataDisneyUniversal(): DisneyUniversalParams {
    return {
      precio_pase: '-',
      precio_plan_comida: '-',
      id_anterior: '-',
    };
  }

  public createItems(hotelStatic?): Item[] {
    const itemsArray = [];

    this.store$.pipe(select(selectResults), take(1)).subscribe((response) => {
      if (hotelStatic !== undefined) {
        const position = response.hotels.findIndex((h: any) => h.id === hotelStatic.id);
        itemsArray.push(
          new ItemParams(
            hotelStatic,
            this.producto,
            response.destination,
            position >= 0 ? position + 1 : undefined,
          ).getData(this.producto),
        );
      } else {
        response.hotels.forEach((hotel, idx) => {
          itemsArray.push(
            new ItemParams(hotel, this.producto, response.destination, idx + 1).getData(
              this.producto,
            ),
          );
        });
      }
    });
    return itemsArray;
  }
}
